import state from "../office/state.ts";

function setDocumentSetting(name: string, value: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!state.loaded || !state.enabled) {
      resolve();
    }

    Office.context.document.settings.set(name, value);
    Office.context.document.settings.saveAsync({}, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve();
      } else {
        reject(result.error);
      }
    });
  });
}

document.addEventListener(
  "set-document-setting",
  async (e: CustomEvent<{ name: string; value: string }>) => {
    await setDocumentSetting(e.detail.name, e.detail.value);
  }
);
